export const asset = (path: string) => `${process.env.PUBLIC_URL}${path}`;
